import { CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const AnnouncerScoredDialog = ({ info, onClose, onGo }) => (
  <Dialog open={!!info} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="bg-[#1C2541] border-emerald-500/50" data-testid="ann-scored-dialog">
      <DialogHeader><DialogTitle className="font-display text-2xl uppercase text-emerald-300 flex items-center gap-2"><CheckCircle2 className="w-6 h-6" />Już oceniona</DialogTitle></DialogHeader>
      {info && (
        <div className="grid gap-3 text-sm">
          <div className="rounded-xl bg-[#0B132B]/70 p-3" data-testid="ann-scored-person">
            <b className="text-white">{info.p.name}</b> ({info.p.category} · {info.p.age_group}) ma już komplet ocen sędziów.
          </div>
          {info.first ? (
            <div className="rounded-xl bg-amber-500/10 border border-amber-500/40 p-3" data-testid="ann-scored-first-open">
              <div className="text-xs uppercase tracking-wider text-amber-300">Pierwsza nieoceniona osoba</div>
              <div className="text-lg font-bold">{info.first.p.order ? `${info.first.p.order}. ` : ""}{info.first.p.name}</div>
              <div className="text-slate-300">{info.first.p.category} · {info.first.p.age_group}{info.first.p.time ? ` · ${info.first.p.time}` : ""}</div>
              {!info.first.p.present && <div className="text-red-300 text-xs mt-1">Niezarejestrowana w Rejestracji</div>}
            </div>
          ) : <div className="text-emerald-300" data-testid="ann-scored-all-done">Wszystkie osoby tego dnia są ocenione.</div>}
          <div className="grid sm:grid-cols-2 gap-2">
            {info.first && <button data-testid="ann-scored-go-first" onClick={() => onGo(info.first.i)} className="h-12 rounded-xl bg-amber-600 hover:bg-amber-500 font-semibold">Przejdź do nieocenionej</button>}
            <button data-testid="ann-scored-go-anyway" onClick={() => onGo(info.i)} className="h-12 rounded-xl border border-white/15 hover:bg-white/5 font-semibold">Mimo to ustaw tę osobę</button>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
